<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showPartnerFinanceTransactionDetailSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div class="sidebar-header-title">TRXN ID: {{transactionId}}</div>
        <div class="sidebar-header-sub-title"></div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 145px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div *ngIf="activeMenuTab === menuTab.TNXNDetails">
                <div class="pft-title">Xpress Transaction</div>

                <div class="flex flex-row flex-wrap">
                    <div class="pft-column-50">
                        <div class="flex flex-row flex-wrap mt-3">
                            <div class="pft-column-50 p-1 pft-label">
                                Transaction date:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.TransactionDate}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Transaction time:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.TransactionTime}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="pft-column-50">
                        <div class="flex flex-row flex-wrap mt-3">
                            <div class="pft-column-50 p-1 pft-label">
                                Payment method:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.PaymentMethodText}}</span>
                            </div>

                            <div class="pft-column-50 p-1 pft-label">
                                Transaction amount:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.TransactionAmount}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pft-title">Delivery Details</div>
                <div class="flex flex-row flex-wrap">
                    <div class="pft-column-50">
                        <div class="flex flex-row flex-wrap mt-3">
                            <div class="pft-column-50 p-1 pft-label">
                                Delivery type:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DeliveryServiceTypeText}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Delivery created:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DeliveryCreatedTime}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Delivery date:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DeliveryCompletedAt}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Delivery time:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DeliveryCompletedTime}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="pft-column-50">
                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Products">
                <p-table [value]="transaction.Products" [tableStyle]="{'min-width': '50rem'}">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th>Product ID </th>
                            <th>Name</th>
                            <th>Price</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-columns="columns">
                        <tr>
                            <td>{{product.ProductId}}</td>
                            <td>{{product.ProductName}}</td>
                            <td>₱ {{product.ProductPrice}}</td>
                            <td>{{product.ProductQuantity}}</td>
                            <td>₱ {{product.ProductTotalPrice}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Payment">
                <div class="pft-title">Order Timeline</div>
                <!--<p-table [tableStyle]="{'min-width': '50rem'}">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th>TX ID </th>
                            <th>MID</th>
                            <th>Xpress Status</th>
                            <th>Partner Status</th>
                        </tr>
                    </ng-template>
                    <tbody>
                        <tr>
                            <td>{{transactionId}}</td>
                            <td>{{transaction.PaymentMIDPayServiceText}}</td>
                            <td>{{transaction.PaymentXpressStatusText}}</td>
                            <td>{{transaction.PaymentPartnerStatusText}}</td>
                        </tr>
                    </tbody>
                </p-table>-->
                <table>
                    <tr>
                        <th>TX ID </th>
                        <th>MID</th>
                        <th>Xpress Status</th>
                        <th>Partner Status</th>
                    </tr>
                    <tr>
                        <td>{{transactionId}}</td>
                        <td>{{transaction.PaymentMIDPayServiceText}}</td>
                        <td>{{transaction.PaymentXpressStatusText}}</td>
                        <td>{{transaction.PaymentPartnerStatusText}}</td>
                    </tr>
                </table>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Messages">
                <div class="pft-title">Store and Customer Messages</div>
                <div *ngIf="transaction.Messages">
                    <div *ngFor="let message of transaction.Messages">

                        <div class="message-outer-block">
                            <div class="message-inner-block-left">
                                <div *ngIf="message.MessageTypeId === 1">
                                    <div class="message-author">Support</div>
                                    <div class="message-border-block message-text-left">{{message.Message}}</div>
                                    <div class="message-date" style="text-align: right;">{{message.CreatedAt}}</div>
                                </div>
                            </div>
                            <div class="message-inner-block-right">
                                <div *ngIf="message.MessageTypeId === 2">
                                    <div style="text-align:right" class="message-author">Customer</div>
                                    <div class="message-border-block message-text-right">{{message.Message}}</div>
                                    <div class="message-date">{{message.CreatedAt}}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div *ngIf="activeMenuTab === menuTab.Timeline">
                <div class="pft-title">Order Timeline</div>
                <div class="pft-title">Order Processing</div>
                <div class="flex flex-row flex-wrap">
                    <div class="pft-column-50">
                        <div class="flex flex-row flex-wrap mt-3">
                            <div class="pft-column-50 p-1 pft-label">
                                Time accepted:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.AcceptedTime}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Start packing:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.PackingStartedTime}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Finished packing:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.ReadyToDispatchTime}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Dispatch:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DispatchTime}}</span>
                            </div>
                            <div class="pft-column-50 p-1 pft-label">
                                Delivered:
                            </div>
                            <div class="pft-column-50 p-1">
                                <span class="pft-value">{{transaction.DeliveredTime}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="pft-column-50">
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </div>

</p-sidebar>